var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useEffect, useImperativeHandle, useRef, useState, } from 'react';
import FormLabelStyle from '../FormLabelStyle';
import SelectStyle, { AbsoluteContentWrapper, SelectedValue, SelectIcon, SelectWrapper, } from './SelectStyle';
/**
 * Gets a list of the selected `<option>` elements which are present inside of a `<select>`.
 *
 * @param select The `<select>` element of which to get the selected options.
 */
function getSelectedOptions(select) {
    if (select.selectedOptions) {
        return Array.from(select.selectedOptions);
    }
    // The 'selectedOptions' property is not supported (IE11)
    return Array.from(select.querySelectorAll(':checked'));
}
const Select = React.forwardRef((_a, externalRef) => {
    var { id, value, label, srOnly: srOnlyProp, error, labelStyle, onChange, children, disabled } = _a, otherProps = __rest(_a, ["id", "value", "label", "srOnly", "error", "labelStyle", "onChange", "children", "disabled"]);
    const srOnly = srOnlyProp || false;
    const [selectedValue, setSelectedValue] = useState('');
    const ref = useRef(null);
    const updateValue = useCallback((select) => {
        const selectedOption = getSelectedOptions(select)[0];
        if (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.textContent) {
            setSelectedValue(selectedOption.textContent);
        }
    }, []);
    const handleChange = useCallback((event) => {
        updateValue(event.target);
        if (onChange) {
            onChange(event);
        }
    }, [onChange]);
    useImperativeHandle(externalRef, () => ref.current);
    useEffect(() => {
        if (ref.current) {
            updateValue(ref.current);
        }
    }, [ref, value]);
    return (React.createElement(React.Fragment, null,
        label && (React.createElement(FormLabelStyle, { srOnly: srOnly, htmlFor: id, label: label, style: labelStyle }, label)),
        React.createElement(SelectWrapper, null,
            React.createElement(SelectStyle, Object.assign({}, Object.assign(Object.assign({}, otherProps), { id,
                value,
                error }), { disabled: disabled, error: error, ref: ref, onChange: handleChange }), children),
            React.createElement(AbsoluteContentWrapper, null,
                React.createElement(SelectedValue, { "data-testid": "selectedValue", disabled: disabled }, selectedValue),
                React.createElement(SelectIcon, null)))));
});
export default Select;
//# sourceMappingURL=Select.js.map